import { useSyncExternalStore } from 'react';

import {
  createAnswerStyleStore,
  type AnswerStyleSnapshot,
  type AnswerStyleStorage,
} from '@/services/answerStyleStore';

// localStorage behind the shared store's async interface. A blocked store (a
// partitioned embed iframe, private mode) throws here; the store catches it and
// keeps the guest's choice in memory for the visit.
const browserStorage: AnswerStyleStorage = {
  getItem: async (key) => window.localStorage.getItem(key),
  setItem: async (key, value) => {
    window.localStorage.setItem(key, value);
  },
};

/**
 * The app's one answer-style store. Read once at startup; `AuthProvider`
 * applies the signed-in account and clears it at sign-out; `ChatContainer`
 * reads it per request.
 */
export const answerStyleStore = createAnswerStyleStore(browserStorage);

if (typeof window !== 'undefined') void answerStyleStore.load();

/** Reactive read of the answer-style snapshot (guest or signed-in account). */
export function useAnswerStyle(): AnswerStyleSnapshot {
  return useSyncExternalStore(
    answerStyleStore.subscribe,
    answerStyleStore.getSnapshot,
    answerStyleStore.getSnapshot
  );
}
